import { spacing, color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
import { valid, invalid } from "./_state.js";
const classNamePrefix = "umd-field-file";
const file = {
  appearance: "none",
  backgroundColor: "transparent",
  cursor: "pointer",
  position: "relative",
  zIndex: 9,
  "&[aria-invalid='true']": {
    ...invalid
  },
  "&[aria-invalid='false']": {
    ...valid
  },
  [`&::file-selector-button, &::-webkit-file-upload-button`]: {
    cursor: "pointer",
    marginRight: spacing.sm
  }
};
const fileWrapper = objectWithClassName({
  backgroundColor: color.white,
  overflow: "hidden",
  position: "relative",
  className: [
    `${classNamePrefix}-wrapper`,
    /** @deprecated Use 'umd-field-file-wrapper' instead */
    "umd-forms-file-wrapper"
  ],
  "& input[type='file']": {
    ...file
  }
});
export {
  fileWrapper
};
//# sourceMappingURL=file.js.map
